/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-28 12:07:45
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 18:05:42
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/PagesCategory/ContentCategory/Header/index.tsx
 */
import React, { useContext } from 'react';

import {
  // isEditing,
  // onAddNewCategory,
  getSearch,
  onSearchChange,
  onSearchTagClose,
  postContentSearch,
  emptySearch,
} from '../slice';
import { useDispatch } from 'react-redux';

import Search from 'src/pages/SalesChannelCategory/PagesCategory/Components/Search';
import { PageCategoryTabContext } from 'src/pages/SalesChannelCategory/PagesCategory/Tabs';
import { useAfterDidMountEffect } from 'src/tools/customHooks';

const Header = (props) => {
  const { target } = props;
  const _d = useDispatch();
  const { uuid: salesChannelUuid } = props;
  const { activeKey } = useContext(PageCategoryTabContext);

  const isCurrent = activeKey == target;

  useAfterDidMountEffect(() => {
    if (!isCurrent) {
      _d(emptySearch());
    }
  }, [isCurrent]);
  const handleOnSearch = (search = []) => {
    const text = search.map((i) => i.value);

    _d(
      postContentSearch({
        body: {
          salesChannelUuid,
          searchText: text,
        },
      }),
    );
  };

  return (
    <Search
      onSearchTagClose={onSearchTagClose}
      onSearchChange={onSearchChange}
      getSearch={getSearch}
      //handleOnSearch={handleOnSearch}
      onSearchHasChange={handleOnSearch}
    />
  );
};
export default Header;
